import { useContext } from 'react';

import { Button, TextField } from '@atom/mui';

import MoveFolderTreeContext from './MoveFolderTreeContext';

import classes from './moveFolderTree.module.css';

const cancelButtonStyle = { marginLeft: '0.3125rem' };

const MoveFolderTreeRowEditor = () => {
  const {
    editing,
    loadingUpdate,
    onChangeEditingName,
    onSaveEditing,
    onCancelEditing,
  } = useContext(MoveFolderTreeContext);

  if (!editing) {
    return null;
  }

  return (
    <div className={classes.editRow}>
      <TextField
        value={editing.name}
        onChange={event => onChangeEditingName(event.target.value)}
        name="name"
      />
      <Button
        onClick={onCancelEditing}
        style={cancelButtonStyle}
        disabled={loadingUpdate}
      >
        CANCEL
      </Button>
      <Button onClick={onSaveEditing} disabled={loadingUpdate} color="primary">
        SAVE
      </Button>
    </div>
  );
};

export default MoveFolderTreeRowEditor;
